<template>
	<div :class="headerClass">
		<div class="header" >
			<a href="https://www.ewway.com/" class="logo"><img src="https://www.ewway.com/images/icon/logo.png"></a>
			<div class="flexC fl-end">
				<div class="menuK">
					<div class="menu flexC">
						<a href="https://www.ewway.com/distribution.html" class="nava">音乐发行</a>
						<a href="https://www.ewway.com/marketing.html" class="nava">音乐营销</a>
						<a href="https://www.ewway.com/service.html" class="nava">服务支持</a>
						<a href="https://myzone.ewway.com/login?la=zh" class="nava">登录</a>
					</div>
				</div>
				<div class="hdEN flexC fl-end">
					<a href="https://www.ewway.com/index.html" @mouseover="mouseoverA" @mouseleave="mouseleaveA" :class="mouseoverAClass">
						<img src="https://www.ewway.com/images/icon/yuyan.png"><p>中文</p><i class="HdJiao"></i>
					</a>
					<div class="NavEN Huans" :style="{'display':showL}" @mouseover="mouseoverL" @mouseleave="mouseleaveL" >
						<a href="https://www.ewway.com/feedbackcn/index.html" class="NavENa flexC Huans">中文</a>
						<a href="https://www.ewway.com/feedback/index.html" class="NavENa flexC Huans">English</a>
					</div>
				</div>                                             
				<a href="javascript:;" class="wapNav"></a>
			</div>
		</div>
	</div>
	
	
</template>

<script>
	export default {
		data() {
			return{
				name:"aaaaa",
				headerClass:"headerL",
				mouseoverAClass:"hdENa flexC",
				showL : "none",
			}
		},
		
		created() {
			 window.addEventListener('scroll', this.scrollToTop);
		},
			
		methods:{
			scrollToTop(){
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				if(scrollTop>100){
					this.headerClass = "headerL header0";
				}else{
					this.headerClass = "headerL";
				}
			},
			mouseoverA(){
				this.mouseoverAClass= "hdENa flexC on";
				this.showL = "block";
			},
			mouseleaveA(){
				this.mouseoverAClass= "hdENa flexC";
				this.showL = "none";
			},
			mouseoverL(){
				this.showL = "block";
			},
			mouseleaveL(){
				this.showL = "none";
			}
		}
		
	}
</script>

<style scoped>
	.headerL{
		width: 100%;
		height: 90px;
		z-index: 99;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		margin: 0 auto;
	}
	.header{
		width: 1200px;
		height: 90px;;
		z-index: 99;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		margin: 0 auto;
		color: #252525;
		align-items: center;
		display: flex;
		justify-content: space-between;
	}
	.header0{
		background: #252525;
	}
	.logo{
		width: 60px;
		display: block;
	}
	.logo a{
		color: #6c6c6c;
		text-decoration: none;
		text-shadow: none;
		font-weight: normal;
	}
	.logo img{
		width: 60px;
		height: 46.19px;
	}
	.el-menu-vertical-demo{
		border-bottom:0px;
	}
</style>